import React, { useEffect, useState } from "react";
import "./TimeModal.css";
import close from "../../../../../../../../assets/close.svg";
import axiosApi from "../../../../../../../../core/interceptor/interceptor";
import { config } from "../../../../../../../../config";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import TimeKeeper from 'react-timekeeper';
import timeImg from '../../../../../../../../assets/clock-icon.png';
import SimpleBarReact from "simplebar-react";

export default function TimeModal(props) {
  const [type, setType] = useState("view");
  const [editTimeData, setEditTimeData] = useState(null);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState([]);

  /*** closes modal *****/
  const closeModal = (data = null) => {
    if (props.closeModal) {
      props.closeModal(data);
    }
  };

  const deleteTimeSlot = () => {
    axiosApi
      .delete(`${config.apiUrl}/times/slot/${editTimeData.id}`)
      .then(() => {
        setType("modify");
      })
      .catch((err) => {
        console.error(err);
      });
  }

  return (
    <>
      <div className="modal TimeModal">
        <div className="modal-header">
          <h2>
            {type === "view"
              ? "Edit Time Slots"
              : type === "modify"
                ? "Modify Time Slots"
                : type === "add"
                  ? "Add Time Slot"
                  : `Edit Time Slot - ${editTimeData && moment(editTimeData.time, 'hh:mm A').format('h:mm A')}`}
          </h2>
          <p>
            {
              ['view', 'modify'].includes(type) &&
              <>Select time slots or&nbsp;
                {
                  type === "view" ? (<span onClick={(e) => { e.preventDefault(); setType("modify"); }}>Add/Modify Time Slots</span>)
                    : type === "modify" ? (<span onClick={(e) => { e.preventDefault(); setType("add"); }}>Add New Time Slot</span>)
                      : ""
                }
              </>
            }
          </p>
          {/* {
            type === 'edit' &&
            <span className="delete" onClick={deleteTimeSlot}>
              <FontAwesomeIcon icon={faTrashAlt} className='adminSidebarFontAwesome' />
            </span>
          } */}
          <span className="close" onClick={closeModal}>
            <img src={close} alt='close-icon' />
          </span>
        </div>
        {
          ["view", "modify"].includes(type) ? <ListTimeSlotComponent selectedData={props.selectedData} type={type} setTimeSlot={(e) => setSelectedTimeSlot(e)} setType={(e) => setType(e)} setData={(e) => setEditTimeData(e)} />
            : <AddEditTimeSlot
              setType={
                (e) => {
                  if (type === 'edit') {
                    setEditTimeData(null);
                  }
                  setType(e);
                }
              }
              editData={type === 'edit' ? editTimeData : null}
            />
        }
        {
          ["view", "modify"].includes(type) && (
            <div className="modal-footer d-flex">
              <button
                className="cancel-btn"
                onClick={() =>
                  type === "modify" ? setType("view") : closeModal()
                }
              >
                Cancel
              </button>
              <button type="submit" onClick={() => closeModal({ type: 'time_slots', data: selectedTimeSlot })}>Confirm</button>
            </div>
          )
        }
      </div>
    </>
  );
}

function ListTimeSlotComponent(props) {
  const loading = useSelector((state) => state.loader.value);
  const [timeSlots, setTimeSlots] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    getTimeSlots();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    props.setTimeSlot([]);
    //eslint-disable-next-line
  }, [props.type]);

  useEffect(() => {
    props.setTimeSlot(selected);
    //eslint-disable-next-line
  }, [selected]);

  useEffect(() => {
    setLoader(loading);
    //eslint-disable-next-line
  }, [loading]);

  const getTimeSlots = () => {
    axiosApi
      .get(`${config.apiUrl}/times/slot`)
      .then((res) => {
        if (res.data && res.data.data) {
          let checkedArr = []
          if (Array.isArray(props.selectedData)) {
            checkedArr = props.selectedData;
          }
          res.data.data.forEach((slot) => {
            slot.checked = checkedArr.includes(slot.time);
          });
          setTimeSlots(res.data.data);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const changeSelection = () => {
    setSelected(timeSlots.filter(time => time.checked).map((tm) => tm.time));
  }

  useEffect(() => {
    changeSelection();
    //eslint-disable-next-line
  }, [timeSlots]);
  return (
    <SimpleBarReact style={{
      maxHeight: 400
    }}>
      <div className={`minh-350 ${props.type === "view" ? " TimeModal-wrapper" : ""}`}>
        {Array.isArray(timeSlots) && timeSlots.length > 0 ? timeSlots.map((x, idx) => (
          <div
            className={`inner-blk ${props.type === "modify" && "cursor-pointer"
              }`}
            onClick={() => {
              if (props.type === "modify") {
                props.setData(x);
                props.setType("edit");
              }
            }}
            key={idx}
          >
            {props.type === "modify" ? (
              <div>
                <span>{x.time}</span>
                <span className="collapsible-arrow"></span>
              </div>
            ) : (
              <label className="checkbox">
                {x.time}
                <input type="checkbox" checked={x.checked} onChange={() => {
                  x.checked = !x.checked;
                  setTimeSlots([...timeSlots]);
                }} />
                <span className="checkmark"></span>
              </label>
            )}
          </div>
        )) :
          (!loader && <div className="noSeason">No Record Found</div>)
        }
      </div>
    </SimpleBarReact>
  );
}

function AddEditTimeSlot(props) {
  const [formData, setFormData] = useState({ time: '' });
  const [showTime, setShowTime] = useState(false);
  useEffect(() => {
    setFormData({ time: props.editData ? props.editData.time : '' });
    //eslint-disable-next-line
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (props.editData) {
      return updateTimeSlot();
    }
    saveTimeSlot();
  };

  const saveTimeSlot = () => {
    const payload = {
      time: formData.time,
    };
    axiosApi
      .post(`${config.apiUrl}/times/slot`, payload)
      .then(() => {
        if (props.setType) {
          props.setType("modify");
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const updateTimeSlot = () => {
    const payload = {
      time: formData.time,
    };
    axiosApi
      .put(`${config.apiUrl}/times/slot/${props.editData.id}`, payload)
      .then(() => {
        if (props.setType) {
          props.setType("modify");
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="ModifyTime-wrapper">
          <div className="input-field cus-width date-field">
            <label>Select Time Slot</label>
            <div className="date-input">
              <input
                onFocus={() => setShowTime(true)}
                type="text"
                name="hour"
                placeholder="Select Time"
                value={formData.time}
                autoComplete='off'
              />
              <div className="icon-blk" onClick={() => setShowTime(true)}>
                <img src={timeImg} alt="clock" />
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer d-flex">
          <button
            className="cancel-btn"
            onClick={(e) => {
              e.preventDefault();
              if (props.setType) {
                props.setType("modify");
              }
            }}
          >
            Cancel
          </button>
          <button type="submit">Confirm</button>
        </div>
      </form>
      {
        showTime &&
        <div className="timepicker-modal">
          <TimeKeeper
            time={formData.time ? moment(formData.time, 'hh:mm A').format('h:mm a') : '12:00 am'}
            doneButton={(times) => (
              <div className="modal-footer">
                <button type='button'
                  className='white-btn btn'
                  onClick={() => {
                    setShowTime(false)
                  }
                  }
                >Close</button>
                <button type='button'
                  className='primary-btn'
                  onClick={() => {
                    setFormData({ time: moment(times.formatted12, 'h:mm a').format('hh:mm A'), })
                    setShowTime(false)
                  }
                  }>
                  Done
                </button>
              </div>
            )}
          />
        </div>
      }
    </>
  );
}
